var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIlustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 98H88.6667C93.8213 98 98 93.8213 98 88.6667V23.3333C98 18.1787 93.8213 14 88.6667 14H23.3333C18.1787 14 14 18.1787 14 23.3333V88.6667C14 93.8213 18.1787 98 23.3333 98ZM23.3333 98L74.6667 46.6667L98 70M46.6667 39.6667C46.6667 43.5327 43.5327 46.6667 39.6667 46.6667C35.8007 46.6667 32.6667 43.5327 32.6667 39.6667C32.6667 35.8007 35.8007 32.6667 39.6667 32.6667C43.5327 32.6667 46.6667 35.8007 46.6667 39.6667Z",
    stroke: "#52575C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIlustration);
export default __webpack_public_path__ + "static/media/photo-ilustration.999204c661cbcdf45873e99ee41804b4.svg";
export { ForwardRef as ReactComponent };